module.exports = __webpack_public_path__ + "static/media/GOLDEN.27ceb7a6.png";